import { createHash } from 'crypto'

import { bankApi, USE_XSRF_HEADER /*, mockApi*/ } from '@/api'
import {
  BillHistoryRowCount,
  IBillPaymentAddFavoriteRequest,
  IBillPaymentGetPulsaProductGroupCodeByPhoneNoRequest,
  IBillPaymentGetPulsaProductGroupCodeByPhoneNoResponse,
  IBillPaymentInquireRequest,
  IBillPaymentInquireResponse,
  IBillPaymentMainRequest,
  IBillPaymentMainResponse,
  IBillPaymentRemoveFavoriteRequest,
  IBillPaymentRemoveRecentRequest,
} from '@/domains/BillPaymentDomain'
import { IEmptyResponse } from '@/domains/CommonDomain'
import { IBillPaymentMainResponse as IBillPaymentMainResponseV2 } from '@/domains/version/V2/BillPaymentDomain'

import { cmodeValue } from '..'

const BASE = '/bill-payment'

export const BILL_PAYMENT_API_URL = {
  BILL_PAY: 'bill-payment/pay',
}

// Bill-Payment Bill 조회
export const fetchBill = (
  data: IBillPaymentInquireRequest,
): Promise<IBillPaymentInquireResponse> => {
  return bankApi.post(`${BASE}/inquire`, data)
  //return mockApi.post(`${BASE}/inquire`, data)
}

// Bill-Paymeny Bill 조회
export const fetchBillBeta = (
  data: IBillPaymentInquireRequest,
): Promise<IBillPaymentInquireResponse> => {
  const checkArrParam: string =
    (data.amount ?? '') + data.customerId + data.productTypeCode + data.productTypeSwitchId
  const checkParam = createHash('sha256')
    .update(checkArrParam)
    .digest('hex')
  // .digest('base64')
  const dateCheckSum = {
    ...data,
    checkParam: checkParam,
  }
  // console.log('sha256 :', checkArrParam, checkParam, dateCheckSum)
  // amount?: string // 지불금액
  // customerId: string // 고객번호
  // productTypeCode: string // ProductType’s code
  // productTypeSwitchId: string // ProductType’s switchId
  // checkParam?: string // checkParam 값

  return bankApi.post({ url: `${BASE}/inquire`, beta: true }, dateCheckSum)
  // return bankApi.post(`${BASE}/inquire`, data)
  //return mockApi.post(`${BASE}/inquire`, data)
}

// Bill-Payment 즐겨찾기 추가
export const addFavoritePayment = (
  data: IBillPaymentAddFavoriteRequest,
): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/favorite/add`, data, USE_XSRF_HEADER)
}

// Bill-Payment 즐겨찾기 삭제
export const removeFavoritePayment = (
  data: IBillPaymentRemoveFavoriteRequest,
): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/favorite/remove`, data, USE_XSRF_HEADER)
}

// Bill-Payment 최근이력 삭제
export const removeRecentPayment = (
  data: IBillPaymentRemoveRecentRequest,
): Promise<IEmptyResponse> => {
  return bankApi.post(`${BASE}/recent/remove`, data, USE_XSRF_HEADER)
}

// Bill-Payment Main
export const fetchBillPaymentMain = (
  data: IBillPaymentMainRequest = { rowCnt: BillHistoryRowCount },
): Promise<IBillPaymentMainResponse> => {
  return bankApi.post(`${BASE}/main`, data)
  // return bankApi.post({ url: `${BASE}/main`, beta: true }, data)
  //return mockApi.post(`${BASE}/main`, data)
}

// Bill-Payment Main V2
export const fetchBillPaymentMainBeta = (
  data: IBillPaymentMainRequest = { rowCnt: BillHistoryRowCount },
): Promise<IBillPaymentMainResponseV2> => {
  // return bankApi.post(`${BASE}/main`, data)
  return bankApi.post(
    { url: `${BASE}/main?${cmodeValue === null ? 'cmode=1' : 'cmode=' + cmodeValue}`, beta: true },
    data,
  )
  //return mockApi.post(`${BASE}/main`, data)
}

// Bill-Payment Product Code
export const fetchBillPaymentGetCode = (): Promise<IBillPaymentMainResponse> => {
  return bankApi.post(`${BASE}/get-code`)
}

// Bill-Payment Pulsa
export const fetchMobileCarrierCode = (
  data: IBillPaymentGetPulsaProductGroupCodeByPhoneNoRequest,
): Promise<IBillPaymentGetPulsaProductGroupCodeByPhoneNoResponse> => {
  return bankApi.post(`${BASE}/product-group-code/by-phoneno`, data)
}
